import { TabLogin } from '@/types';
import { useMemo, useState } from 'react';
import { ListTabContext } from './hook';

export const ListTabProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [listTab, setListTab] = useState<Array<TabLogin>>([]);
  // Phân biệt "chưa biết quyền" với "không có quyền": lúc mới tải trang listTab
  // luôn rỗng, nếu guard kết luận ngay thì mọi màn đều ra 403.
  const [isListTabLoaded, setIsListTabLoaded] = useState(false);

  const value = useMemo(
    () => ({ listTab, setListTab, isListTabLoaded, setIsListTabLoaded }),
    [listTab, isListTabLoaded],
  );

  return (
    <ListTabContext.Provider value={value}>{children}</ListTabContext.Provider>
  );
};
